// components/PoolTableRow.js
import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import useWallet from "../../../hooks/useWallet";
import { useStake } from "../../../hooks/useStake";
import { useTheme } from "../../../hooks/ThemeProvider";
import { defaultUserProfile } from "../../../utils/constant";
import Tvl from "../../../shared/Tvl";
import ChildPoolApr from "../../../shared/ChildPoolApr";
// import { calculateAPR, calculateChildPoolAPR } from "../../../utils/unifarmAprCalculator";
const PoolTableRow = ({ pool, index, onShare, rootPoolData }) => {
    const { theme } = useTheme();
    // console.log(pool, rootPoolData, 'poolpoolpool');
    const [availableStakes, setAvailableStakes] = useState();
    const { address } = useWallet()
    const { getAvailableStakes } = useStake()
    const [tvlAmount, setTvlAmount] = useState(0);
   
    // const childAPR = calculateAPR(rootPoolData?.rewardAmount, rootPoolData?.poolEndDate, tvlAmount)
    
    // calculateChildPoolAPR(
    //     rootPoolData?.rewardAmount,   // might come from parent component
    //     rootPoolData?.poolEndDate,              // might be stored separately
    //     tvlAmount,          // from local state
    //     tvlAmount,        // from global context
    //     pool?.creatorFeePercent           // from pool config
    // );
    useEffect(() => {

        if (pool) {
            fetchAvailableStakes()
        }

    }, [pool])

    const fetchAvailableStakes = useCallback(async () => {
        if (!pool?.contractAddress || !address) return;

        try {
            const stakes = await getAvailableStakes(pool?.contractAddress, address);

            // console.log(stakes)

            // Structure the data cleanly
            setAvailableStakes({
                amountETH: stakes?.amountETH || "0",
                restakeAmountETH: stakes?.restakeAmountETH || "0",
                claimCountdown: stakes?.claimCountdown || "00D:00H:00M",
                amountNumber: stakes?.amountNumber || 0,
                restakeAmountNumber: stakes?.restakeAmountNumber || 0,
                claimTime: stakes?.claimTime
            });

        } catch (error) {
            console.error("Failed to fetch available stakes:", error);
            setAvailableStakes({
                amountETH: "0",
                restakeAmountETH: "0",
                claimCountdown: "00D:00H:00M",
                amountNumber: 0,
                restakeAmountNumber: 0,
            });
        }
    }, [pool, address, getAvailableStakes]);
    // console.log(pool, 'rootPoolDatarootPoolData');
    return (
        <div className="table_innner">
            <h4 className="one_sidee">{index + 1}</h4>
            <div className="under_table">
                <img src={pool?.createdBy?.imageUrl ? pool?.createdBy?.imageUrl : defaultUserProfile?.imageUrl} className="imgtable" alt="Pool" />
                <h4 className="uniwhitre">{pool?.createdBy?.name || defaultUserProfile?.name}</h4>
            </div>
            <h4> <ChildPoolApr childPoolContractAddress={pool?.contractAddress} rootPoolAddress={rootPoolData?.contractAddress} rootPoolEndDate={rootPoolData?.poolEndDate} rootPoolRewardAmount={rootPoolData?.rewardAmount} rootPoolStartDate={rootPoolData?.createdAt}/></h4>
            <h4><Tvl poolType={"childPool"} contractAddress={pool?.contractAddress} setTvlAmount={setTvlAmount} tokenAddress={rootPoolData?.rewardToken}></Tvl></h4>
            <h4>{pool?.creatorFeePercent}%</h4>
            {/* <h4>90-day</h4> */}
            <h4><h6 className="grey">
                {availableStakes?.amountETH
                    ? Number(availableStakes.amountETH).toLocaleString(undefined, { maximumFractionDigits: 4 })
                    : 0}
            </h6>
            </h4>
            <div className="butttons_div">
                <h5 onClick={() => onShare(pool, true)}>
                    {
                        theme === 'dark' ? <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                        >
                            <path
                                d="M7 1.16667V8.75"
                                stroke="white"
                                strokeWidth="1.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M9.33333 3.5L7 1.16667L4.66667 3.5"
                                stroke="white"
                                strokeWidth="1.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M2.33333 7V11.6667C2.33333 11.9761 2.45625 12.2728 2.67504 12.4916C2.89383 12.7104 3.19058 12.8333 3.5 12.8333H10.5C10.8094 12.8333 11.1062 12.7104 11.325 12.4916C11.5437 12.2728 11.6667 11.9761 11.6667 11.6667V7"
                                stroke="white"
                                strokeWidth="1.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                            :
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M7 1.16666V8.74999" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.33366 3.49999L7.00033 1.16666L4.66699 3.49999" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M2.33301 7V11.6667C2.33301 11.9761 2.45592 12.2728 2.67472 12.4916C2.89351 12.7104 3.19026 12.8333 3.49967 12.8333H10.4997C10.8091 12.8333 11.1058 12.7104 11.3246 12.4916C11.5434 12.2728 11.6663 11.9761 11.6663 11.6667V7" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                    }

                </h5>
                <Link to={`/stakingpool?id=${pool?._id}`}>
                    <button>
                        Details{" "}


                        {
                            theme === 'dark' ? <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                            >
                                <path
                                    d="M9 4L11 6L9 8"
                                    stroke="white"
                                    strokeWidth="1.25"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M1 6H11"
                                    stroke="white"
                                    strokeWidth="1.25"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                                : <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                    <path d="M9 4L11 6L9 8" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M1 6H11" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                        }


                    </button>
                </Link>
            </div>
        </div>
    );
};

export default PoolTableRow;